import React from "react";

const FilterLeft = ({ filters = {}, selectedFilters = {}, onFilterChange }) => {
  return (
    <div className="box_shadow">
      <div className="accordion" id="filterAccordion">

        {/* Price */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button fs-5 fw-semibold collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-Price">
              Price
            </button>
          </h2>

          <div id="collapse-Price" className="accordion-collapse collapse">
            <div className="accordion-body">
              {(filters.priceRanges || []).map((price, i) => (
                <div className="form-check w-100" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedFilters.price?.includes(price) || false}
                    onChange={(e) =>
                      onFilterChange("price", price, e.target.checked)
                    }
                  />
                  <label className="form-check-label">{price}</label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bus Timings */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button fs-5 fw-semibold collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-BusTimings">
              Bus Timings
            </button>
          </h2>

          <div id="collapse-BusTimings" className="accordion-collapse collapse">
            <div className="accordion-body">
              {(filters.timings || []).map((time, i) => (
                <div className="form-check w-100" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedFilters.timings?.includes(time) || false}
                    onChange={(e) =>
                      onFilterChange("timings", time, e.target.checked)
                    }
                  />
                  <label className="form-check-label">{time}</label>
                </div>
              ))}
            </div>
          </div>
        </div>

         {/* Bus Type */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading-BusType">
            <button className="accordion-button fs-5 fw-semibold collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-BusType">
              Bus Type
            </button>
          </h2>

          <div id="collapse-BusType" className="accordion-collapse collapse">
            <div className="accordion-body">
              {(filters?.busTypes || []).map((type, i) => (
                <div className="form-check w-100" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="busTypes"
                    id={`BusType-${i}`}
                    checked={selectedFilters?.busTypes?.includes(type) || false}
                    onChange={(e) => onFilterChange("busTypes", type, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`BusType-${i}`}>
                    {type}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Travels */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading-Travels">
            <button className="accordion-button fs-5 fw-semibold collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-Travels">
              Travels
            </button>
          </h2>

          <div id="collapse-Travels" className="accordion-collapse collapse">
            <div className="accordion-body">
              {(filters?.travels || []).map((travel, i) => (
                <div className="form-check w-100" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="travels"
                    id={`Travels-${i}`}
                    checked={selectedFilters?.travels?.includes(travel) || false}
                    onChange={(e) => onFilterChange("travels", travel, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`Travels-${i}`}>
                    {travel}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Boarding Points */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading-BoardingPoints">
            <button className="accordion-button fs-5 fw-semibold collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-BoardingPoints">
              Boarding Points
            </button>
          </h2>

          <div id="collapse-BoardingPoints" className="accordion-collapse collapse">
            <div className="accordion-body">
              {(filters?.boardingPoints || []).map((point, i) => (
                <div className="form-check w-100" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="boardingPoints"
                    id={`BoardingPoints-${i}`}
                    checked={selectedFilters?.boardingPoints?.includes(point) || false}
                    onChange={(e) => onFilterChange("boardingPoints", point, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`BoardingPoints-${i}`}>
                    {point}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Dropping Points */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading-DroppingPoints">
            <button className="accordion-button fs-5 fw-semibold collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-DroppingPoints">
              Dropping Points
            </button>
          </h2>

          <div id="collapse-DroppingPoints" className="accordion-collapse collapse">
            <div className="accordion-body">
              {(filters?.droppingPoints || []).map((point, i) => (
                <div className="form-check w-100" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="droppingPoints"
                    id={`DroppingPoints-${i}`}
                    checked={selectedFilters?.droppingPoints?.includes(point) || false}
                    onChange={(e) => onFilterChange("droppingPoints", point, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`DroppingPoints-${i}`}>
                    {point}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterLeft;

